require('./mortgageRequestWorkForm.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @constants
const { mortgageRequestPreApprovalCommons, laborSituationOptions, studiesLevelOptions } = require('constants/mortgageRequestPreApproval');

class MortgageRequestWorkForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleWork = this.handleWork.bind(this);
        this.handleSecondWork = this.handleSecondWork.bind(this);
        this.handleStudies = this.handleStudies.bind(this);
        this.handleSecondStudies = this.handleSecondStudies.bind(this);
    }

    buildOptions(list) {
        const options = list.options
        return Object.keys(options).map((value) => ({
            value,
            label: formatText(options[value])
        }));
    }

    handleWork(value) {
        this.props.formHandlers.handleWork(value, mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE);
    }

    handleSecondWork(value) {
        this.props.formHandlers.handleWork(value, mortgageRequestPreApprovalCommons.HOLDER_OPTION_TWO);
    }

    handleStudies(value) {
        this.props.formHandlers.handleStudies(value, mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE);
    }

    handleSecondStudies(value) {
        this.props.formHandlers.handleStudies(value, mortgageRequestPreApprovalCommons.HOLDER_OPTION_TWO);
    }

    getSelected(holder) {
        const { immMortgageRequest } = this.props;

        return {
            work: immMortgageRequest.getIn(['holders', holder, 'work', 'value']),
            study: immMortgageRequest.getIn(['holders', holder, 'studies', 'value'])
        }
    }

    getErrors(holder) {
        const { validModal } = this.props;
        const valid = validModal.get('valid');

        return {
            work: valid ? true : validModal.getIn(['fields', holder, 'work'], true),
            study: valid ? true : validModal.getIn(['fields', holder, 'studies'], true)
        }
    }

    buildHolderOneFields() {
        const { immMortgageRequest, responsiveMobileVersion } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const oneHolder = selectedHolder === mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE;
        const selected = this.getSelected(mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE);

        const valid = this.getErrors(mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE);

        const studies = this.buildOptions(studiesLevelOptions);
        const works = this.buildOptions(laborSituationOptions);

        const css = classNames(
            { 'col-md-8': oneHolder, 'col-md-5': !oneHolder }
        );
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersion ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle mortgage-request-marital-status-and-dependents__desktopVersionTitleHeight ';

        return (

            <div className="row">
                <div className={cssContainerTitle}  >
                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-firstOwner" />

                        }
                    </div>

                </div>
                <div className={cssContainer}>
                    <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>

                        <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-workTitle" />
                    </label>
                    <OKSelect
                        onChange={this.handleWork}
                        options={works}
                        value={selected.work}
                        errorState={!valid.work}
                        searchable={false}
                    />
                </div>
                <div className={cssContainer}>

                    <div class="ok-select">
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>

                            <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-studies" />
                        </label>
                    </div>

                    <OKSelect
                        onChange={this.handleStudies}
                        options={studies}
                        value={selected.study}
                        searchable={false}
                        errorState={!valid.study}
                    />
                </div>
            </div>
        );
    }

    buildHolderTwoFields() {
        const { immMortgageRequest, responsiveMobileVersion } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const selected = this.getSelected(mortgageRequestPreApprovalCommons.HOLDER_OPTION_TWO);
        const valid = this.getErrors(mortgageRequestPreApprovalCommons.HOLDER_OPTION_TWO);
        const studies = this.buildOptions(studiesLevelOptions);
        const works = this.buildOptions(laborSituationOptions);
        const cssContainer = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersion ';
        const cssContainerTitle = responsiveMobileVersion ? 'col-sm-12' : 'col-md-4 mortgage-request-marital-status-and-dependents__desktopVersionTitle ';
        return (

            <div className={!responsiveMobileVersion ? 'row mortgage-request-marital-status-and-dependents__margintop-15' : "row"}>
                <div className={cssContainerTitle}>
                    <div className="mortgage-request-marital-status-and-dependents__label"  >
                        {responsiveMobileVersion && selectedHolder === mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE ? null :
                            <FormattedText value="mortgageRequestPreApprovalStepThree-secondOwner" />
                        }

                    </div>
                </div>
                <div className={cssContainer}>
                    {responsiveMobileVersion &&
                        <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                            <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-workTitle" />
                        </label>
                    }
                    <OKSelect
                        onChange={this.handleSecondWork}
                        options={works}
                        value={selected.work}
                        errorState={!valid.work}
                        searchable={false}
                    />
                </div>
                <div className={cssContainer}>
                    <div class="ok-select">
                        {responsiveMobileVersion &&

                            <label className='ok-select__label mortgage-request-marital-status-and-dependents__margintop-15'>
                                <FormattedText noWrapper={true} value="mortgageRequestPreApprovalStepThree-studies" />
                            </label>
                        }

                    </div>
                    <OKSelect
                        onChange={this.handleSecondStudies}
                        options={studies}
                        value={selected.study}
                        searchable={false}
                        errorState={!valid.study}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { immMortgageRequest } = this.props;
        const selectedHolder = immMortgageRequest.get('selectedHolder');
        const holderOneFields = this.buildHolderOneFields();
        const holderTwoFields = selectedHolder !== mortgageRequestPreApprovalCommons.HOLDER_OPTION_ONE ? this.buildHolderTwoFields() : null;
        return (
            <div className="row mortgage-request-work-form">
                <div className="col-md-11">
                    <OKBoxTitle value={formatText('mortgageRequestPreApprovalStepThree-work')} size="medium" />
                </div>
                <div className='container-fluid'>
                    {holderOneFields}
                    {holderTwoFields}
                </div>
            </div>
        );
    }
}

MortgageRequestWorkForm.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    validModal: PropTypes.object
}

module.exports = MortgageRequestWorkForm;
